import { render, staticRenderFns } from "./InstanceOperateStatus.vue?vue&type=template&id=4036b206&scoped=true&"
import script from "./InstanceOperateStatus.vue?vue&type=script&lang=js&"
export * from "./InstanceOperateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4036b206",
  null
  
)

export default component.exports